
import { Country } from '@/lib/models/Country'
import { User } from '@/lib/models/User'
import { Vehicle } from '@/lib/models/Vehicle'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class VehicleNonPublicInfo extends Vue {
  @Prop({ required: true, default: () => new Vehicle() }) vehicle!: Vehicle

  countries: Country[] = []

  mounted () {
    this.loadCountries()
  }

  async loadCountries () {
    this.countries = await Country.getAll({})
  }

  responsibleCustomerIdChanged (input: any) {
    setTimeout(() => {
      const customer = this.$store.state.PageURLTeam.team.members.find((user: User) => user.id === this.vehicle.responsibleCustomerId)
      if (!customer) {
        return
      }
      this.vehicle.vehicleOwner = `${customer.firstname} ${customer.lastname}`
      this.$emit('inputChanged')
    }, 0)
  }
}
